<template>
  <div id="customers">
    <h1 class="title is-2">{{ $t('Customers.title') }}</h1>

    <div class="block">

      <!-- <button class="button is-small refresh" @click="loadCustomers"
        style="margin:20px 0; min-width: 38px; border-radius:6px;" :class="{'is-loading':isLoading}">
        <svg v-if="!isLoading" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-rotate-cw">
          <polyline points="23 4 23 10 17 10"></polyline>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
        </svg>
      </button> -->

      <div v-if="!isLoading && customers.length==0" class="notification">
        <p>{{ $t('Customers.emptyNote') }}</p>
        <a :href="`https://`+place.url+'.'+place.domain" target="_blank">https://{{place.url}}.{{place.domain}}</a>
      </div>

      <!-- <vuetable v-if="customers.length> 0" ref="vuetable"
                :fields="fields"
                :api-mode="false"
                :data="customers"
                :css="css.table"
              ></vuetable> -->

        <!-- :noItemsView="{ noResults: 'Nothing found...' }"  -->
      <CDataTable :items="customers" :fields="fields1" :loading="isLoading"
        @row-clicked="toggleDetails" 
        :items-per-page="15" hover sorter pagination clickableRows column-filter>
         <template #avatar="{item}">
        <td>
          <img :src="'https://www.gravatar.com/avatar/'+getHash(item.email)+'?d=mp'" alt="">
        </td>
      </template>
         <template #date="{item}">
        <td>
          {{formatDate(item.date)}}
        </td>
      </template>
         <template #phone="{item}">
        <td>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          {{item.phone}}
        </td>
      </template>

        <template #show_details="{}">
          <!-- <td class="py-2">
            <button class="button is-info is-outlined is-small" @click="toggleDetails(item, index)">
              {{Boolean(item._toggled) ? $t('Customers.hide') : $t('Customers.show')}}
            </button>
          </td> -->
        </template>
        <template #details="{item}">
          <CCollapse class="inner" :show="Boolean(item._toggled)" :duration="collapseDuration">
            <CCardBody>
              <div class="columns">
                <div class="column" style="max-width: 394px;">
                    <!-- :aside-image-props="{ height: 102, src: ' data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuwAAAbsBOuzj4gAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAUgSURBVHic7ZpdbJNVGMd/z9u3XffB4oQtMj9GDFHjbtBIQriAGIIRozEQFzGAds74QQxXGi/0ynhhlMSImpCobAYDxI6pxCDXXkgMMeIXGiRR+V43QWCsa/v2PF6M4Vhbtvact9Ww313b8/zf5/x7enrOc46oKtVAksfrkeh94D0ILES0HaWd4dZGPM0hZhQxg0SCAUywWXuaz1Qlr7ANkN2nO9HIK6APAY0FDVJtxbICP3cUP7NJu+d8Hmp+YRkgu07eTNR/FeVxwCvZsJgBk4lljxAZW6/dzd+4zXCc0olZIP2DK/D971ES1s/IxhaSadovvekXnCQ3BecGSHLoeZB9QIszUeMJ6fo3pTfziTPNSzg1QJKppxF9B/Bd6l4mXdclH45tdynpzABJDi9HeNeVXkkydeulN7PJlZyTSVCSp1sR7xAwr+zg6SbBYnhqiI90amLOr+UHT5GyFRhXibxMJZ2vFCMeQWynCylrA2TgVAeqz7lIpiyysUXycXqprYz9CDCRF4GYtU7ZCIxFttqqWBkgIMAa2yQqJud3imUf7EZAMrUEmG+lYYN6Hn2jPTYSdgYIq6ziXZD3NtiE2xqwwCreBerdaBNuZ4DSbhXvAvWuswm3/Reo3e9/AiOFW+wysDUgaxnvAmMTbGvAKct4ezwdsQq3erjISat4F4g5axNuOQmq9WbEGk8PW4VbPVwk1HrdjPCCLTbh1tth6U/9BHRWLFDJdniCSD6jz0TilQs42Q7rDnuNCvFzX9lK2Bug3hZgyFqnXDw1NOStlsHgwADtah1B5DVbnbKJjn2mjzUO2sq4qQiZoa3Ad060ZkIkSJMZecKFlBMDtOvOLEHwMGD9jUyLZwyx0Xt1Y6vVAuiynAsRAF3bfgxlNZB2pVmAKMTHnnV5SuT0XEC72vbjmeWA+xVixOSJjyY00fC+S1nnJ0O65oYDBN5iwN1Znh+M4OcXa3fjR840LxHK2aCunXeSn9uWIpIA/qxYyDMB9WMfcMpv0Z5oKJNs+MfjXx6p42JzApVHEV0GRK5oUGwl6Adn8YO91I1u1HXXnw81v2pdkACQT0/MJR+9H1iI0I5KO2dbFuOZM2AGwfxCJHhLE82/VS2nahrwXySUOeD/xDVvQDjn+JMQEHam2vBNB0JDQYOROYsK3lPOYfQAPU2H1LLmN21+LucAGRi+m3x+FSIdwAKEDpRbgNJ79qvVA0Qholk8cwHMEJjj1NGrG+LOtuD2BZEd51qIZtch2gMUfpvTUUlBJJJPEwu+IK8v6VPx38sX+JeKDBAQBlIrMNIDuhqoqzgDm4oQCtHcUfzce3Q3bq7k51K2AbJruB3f9AEry31YUawMmEQs+AvRleWuGMv6F5D+1Bp88wOuOu+SrD+XXORb2ZZ+o5ywGY0ASQ41IeZtkCcrTrAUrkbAZGLZwzTmls2kYjTtCJDdw/fg6cFQOh8W2dhtnK8/Jn1j09YMrzoCJDl8O2L24/LS41TCGAETeEaJpx/QROO+kk1KfTB+9c3sJczOh43xhEz9Hum7cEepJkUNkL4/4uDtAW4NLblqkfeiZOoPSN/fRe8RFBggIDQ1bEdYEn52VSLvNxE0/FjsQlXhCOhPvQ48Uo28qko2dhPbsl9PffuKSVAGhudjzAnGr79VhzAnwWI0XLxLE40HJ15eOQKyQR3V7HwtMKZp8strvh4wa0CtE6g1swbUOoFaM2tArROoNbMG1DqBWjNrQK0TqDXXvAH/AP44oe2VdIIAAAAAAElFTkSuQmCC' }"> -->
                    <!-- <img :src="'https://www.gravatar.com/avatar/'+getHash(item.email)+'?d=identicon'" alt=""> -->
                    <!-- <h4>
                      {{item.name}}
                    </h4> -->
                    <!-- <p class="text-muted">{{$t('Customers.fields.dateFirst')}}: {{formatDate(item.date)}}</p> -->
                  <label class="label" for="">{{$t('Customers.fields.email')}}</label>
                  <input @click.stop="()=>{}" class="input" v-model="item.email" disabled style="" />
                  <label class="label" for="">{{$t('Customers.fields.name')}}</label>
                  <input @click.stop="()=>{}" class="input" v-model.lazy="item.name" style="" />
                  <label class="label mt-1" for="">{{$t('Customers.fields.phone')}}</label>
                  <input @click.stop="()=>{}" class="input" v-model.lazy="item.phone" style="" />
                </div>
                <div class="column">
                                    <label class="label" for="">{{$t('Customers.fields.address')}}</label>
                  <input @click.stop="()=>{}" class="input" v-model="item.address" type="text" style="" />
                  <label class="label" for="">{{$t('Customers.fields.comment')}}</label>
                  <textarea @click.stop="()=>{}" v-model="item.comment" class="input" style="height:112px;"></textarea>

                </div>
                <div class="column is-narrow">
                  <label class="label" for="">{{$t('Customers.fields.discount')}}</label>
                  <input @click.stop="()=>{}" @keypress="onlyNumber" class="input" v-model="item.discount" placeholder="15%" type="text" style="max-width:100px;" />
                </div>
              </div>
              <p v-if="item.referrer" style="margin-top: -12px;margin-bottom: 1rem;"><label class="label" style="display:inline-block">{{$t('Customers.fields.referrer')}}</label>: {{item.referrer}}</p>
                  <button :class="{ isLoading: item.isLoading }"  @click.stop="updateCustomer(item)" class="button is-success">{{$t('DashboardTable.save')}}</button>
                  <button class="button" style="display:inline-block; margin-left: 1rem;">{{$t('DashboardTable.close')}}</button>
            </CCardBody>
          </CCollapse>
        </template>
      </CDataTable>


    </div>
    <!-- <div v-bind:class="{disabledElement : !place.reservations.enabled}">
      </div> -->
    <!-- <button class="button is-info mt-2" @click="saveEditedInfo" v-bind:class="{ isLoading: isLoading }">{{ $t('Reservations.save') }}</button> -->


    <!-- </div>
    </div> -->
  </div>

</template>

<script>
import api from "../api";
import { mapActions, mapGetters } from "vuex";
import _ from "underscore";
import Vuetable from 'vuetable-2'
var crypto = require("crypto");
var request = require("request");
var moment = require('moment')

export default {
  name: "Customers",
  components: {
    Vuetable
  },
  computed: _.extend(
    {},
    mapGetters({
      place: "getPlaceInfo"
    }),
    {
      fields11: function() {
        return 
          
      },
    }
  ),
  data() {
    return {
      isLoading: false,
      isFalse: false,
      customers: [],
      fields1: [],
      
      // fields1: [
      //   { key: 'email', label: 'Mail', _style:'min-width:200px' },
      //   'name',
      //   { key: 'phone', _style:'min-width:100px;' },
      //   { key: 'referrer', _style:'min-width:100px;' },
      //   { 
      //     key: 'show_details', 
      //     label: '', 
      //     _style: 'width:1%', 
      //     sorter: false, 
      //     filter: false
      //   }
      // ],
      details: [],
      collapseDuration: 500,
      css: {
        table: {
          tableWrapper: "",
          tableHeaderClass: "",
          tableBodyClass: "",
          tableClass: "table is-narrow is-fullwidth is-striped is-bordered is-hoverable",
          loadingClass: "is-loading",
          ascendingIcon: "fa fa-chevron-up",
          descendingIcon: "fa fa-chevron-down",
          ascendingClass: "sorted-asc",
          descendingClass: "sorted-desc",
          sortableIcon: "fa fa-sort",
          detailRowClass: "vuetable-detail-row",
          handleIcon: "fa fa-bars text-secondary",
          renderIcon(classes, options) {
            let sortIcon = classes.shift();
            let fontIcon = classes.join(" ");
            return `<span class="icon is-small ${sortIcon}"><i class="${fontIcon}"</i></span>`;
          }
        },
      }

    
    };
  },

  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    getHash(email){
      return crypto.createHash('md5').update(email).digest("hex");
    },
    updateCustomer(item) {
      this.$set(item,"isLoading",true)
      // item.isLoading = true
      item.url = this.place.url
      api.updateCustomer(item).then(response => {
        console.log(response.data);
        item._toggled = false;
        this.$set(item,"isLoading",false)
        
      })
      
    },
    toggleDetails (item) {      
      this.$set(this.customers[item.id], '_toggled', !item._toggled)
      
            this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    loadCustomers () {
      this.isLoading = true
      api.getCustomers(this.place.url, this.place.identityId).then(response => {
        this.isLoading = false
        this.customers = _.sortBy(response.data, 'date').reverse()
        this.customers = this.customers.map((item, id) => { return {...item, id}})
      })
    },
    formatDate(value) {
       return moment(value).format("DD MMM'YY") 
    },
    onlyNumber ($event) {
   //console.log($event.keyCode); //keyCodes value
   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
      $event.preventDefault();
   }
}
    }),
  mounted() {
    moment.locale(this.$i18n.locale)
    this.$title = this.$t('title') + " | " + this.$t('Customers.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: Customers', label : null, value : null})
    this.isLoading = true
    // let _place = this.place

    this.fields1 = [
      { key: 'avatar',label:"", sorter: false, filter: false, _style:'min-width:64px;'},
      { key: 'name', label: this.$t('Customers.fields.name'), _style:'min-width:150px; width:auto', _classes: 'pl-4' },
      { key: 'email', label: this.$t('Customers.fields.email'), _style:'min-width:100px' },
      // { key: 'address', label: this.$t('Customers.fields.address'), _style:'min-width:200px;' },
      { key: 'phone', label: this.$t('Customers.fields.phone'), _style:'min-width:200px;' },
      { key: 'date', label: this.$t('Customers.fields.dateFirst'), _style:'min-width:120px;', filter: false},
      // { key: 'referrer', label: this.$t('Customers.fields.referrer'), _style:'max-width:100px;' },
      // { 
      //   key: 'show_details', 
      //   label: '', 
      //   _style: 'width:1%', 
      //   sorter: false, 
      //   filter: false
      // }
    ]
  

  this.loadCustomers()
    
    
  }
};
</script>

<style scoped>
.refresh:focus {
  outline: none;
  box-shadow: none;
  border-color: #dbdbdb;} 
/* td.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
} */
.vuetable-td-field2 {
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-body {
    margin-top: -3px;
    background-color: white;
    border-bottom: 1px solid #dbdbdb;
}

.table th {
  border: none;
    border-top: 3px solid #dbdbdb94;
    /* border-width: 3px; */
}

.feather.feather-phone {
	color: #424b55;
	height: 16px;
	margin-top: -3px;
	margin-right: -4px;
}

.page-link {
 color:#606c66;
}



</style>